export default __webpack_public_path__ + "4da485bef5e95a6257a579fde042413b.svg";